module.exports = __webpack_public_path__ + "495b03b4e0d487c5e6593727e55c4b43.png";